import { MailOutlined } from '@ant-design/icons';
import { FacebookPartnerBadge, MetaBadge, MetaIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LLRReportVersion } from '../WebsiteReport';
import styles from '../WebsiteReportSummaryVersionB.module.css';

export const ReportHeader = ({
  activeVersion,
  setActiveVersion,
  isMobile,
  withLogos = true,
}: {
  activeVersion: LLRReportVersion;
  setActiveVersion: (version: LLRReportVersion) => void;
  isMobile?: boolean;
  withLogos?: boolean;
}) => {
  const isMetaActive = activeVersion === 'B';
  const history = useHistory();

  const onToggle = (version: LLRReportVersion) => {
    setActiveVersion(version);
    history.replace(history.location.pathname.replace(activeVersion, version));
  };

  return (
    <div className={classNames(styles.row, styles.headerContainer)}>
      <div className={classNames(styles.row, styles.headerContent)}>
        <Logo className={styles.logo} />
        <div className={classNames(styles.row, styles.reportSwitcher)}>
          <span className={classNames({ [styles.inactive]: !isMetaActive })}>
            Meta Report
          </span>
          <div className={styles.manualSwitch}>
            <span
              className={classNames(styles.box, styles.meta, {
                [styles.switchHandle]: isMetaActive,
              })}
              onClick={() => onToggle('B')}
            >
              <MetaIcon
                className={classNames({ [styles.metaIcon]: !isMetaActive })}
              />
            </span>
            <span
              className={classNames(styles.box, styles.email, {
                [styles.switchHandle]: !isMetaActive,
              })}
              onClick={() => onToggle('A')}
            >
              <MailOutlined className={styles.emailIcon} />
            </span>
          </div>
          <span className={classNames({ [styles.inactive]: isMetaActive })}>
            Email Report
          </span>
        </div>
        {!isMobile && withLogos && (
          <div className={styles.badges}>
            <MetaBadge className={styles.badge} />
            <FacebookPartnerBadge
              className={styles.badge}
              width={100}
              height={44}
            />
          </div>
        )}
      </div>
    </div>
  );
};
